import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Tarjeta de contacto que muestra dirección y datos de contacto de un geomarcador.
 */
@Component({
  selector: 'app-contact-card',
  imports: [TranslateModule],
  templateUrl: './contact-card.html',
  styleUrl: './contact-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactCard {
  /**
   * Línea de dirección o calle del geomarcador.
   */
  readonly address = input<string>('');

  /**
   * Teléfono de contacto.
   */
  readonly phone = input<string>('');

  /**
   * Correo electrónico de contacto.
   */
  readonly email = input<string>('');

  /**
   * Sitio web asociado.
   */
  readonly website = input<string>('');

  /**
   * Nombre de la ciudad donde se ubica el geomarcador.
   */
  readonly cityName = input<string | undefined>('');

  /**
   * Nombre del departamento/estado donde se ubica el geomarcador.
   */
  readonly departamentName = input<string | undefined>('');

  /**
   * Dirección completa combinando dirección, ciudad y departamento.
   * @returns Dirección completa como cadena (puede contener campos vacíos).
   */
  protected readonly addressFull = computed<string>(() => {
    return `${this.address() || ''}, ${this.cityName() || ''}, ${this.departamentName() || ''}`;
  });
}
